import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons/faDoorOpen';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faMoneyBillTransfer } from '@fortawesome/pro-solid-svg-icons/faMoneyBillTransfer';
import { faSignature } from '@fortawesome/pro-solid-svg-icons/faSignature';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import { CommissionEarned } from '../Pages/Referrals/CommissionEarned';
import { ReferralsSent } from '../Pages/Referrals/ReferralsSent';
import { ReferralsSummary } from '../Pages/Referrals/ReferralsSummary';
import { SignUps } from '../Pages/Referrals/SignUps';
import { SuggestibleRouteInterface } from '../../_Global/Types/RouteTypes';

const ReferralRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Referrals Summary',
		path: '/manage-account/referrals/summary',
		icon: faDoorOpen,
		colour: ColourStateSolid.Secondary,
		element: <ReferralsSummary />,
		group: 'Referrals',
	},
	{
		title: 'Commission Earned',
		path: '/manage-account/referrals/commission-earned',
		icon: faMoneyBillTransfer,
		colour: ColourStateSolid.Secondary,
		element: <CommissionEarned />,
		group: 'Referrals',
	},
	{
		title: 'Referrals Sent',
		path: '/manage-account/referrals/sent',
		icon: faMegaphone,
		colour: ColourStateSolid.Secondary,
		element: <ReferralsSent />,
		group: 'Referrals',
	},
	{
		title: 'Sign-Ups',
		path: '/manage-account/referrals/sign-ups',
		icon: faSignature,
		colour: ColourStateSolid.Secondary,
		element: <SignUps />,
		group: 'Referrals',
	},
];

export { ReferralRoutes };
